export const validation = {
  maxTitleChar: 60,
  maxParagraphChar: 30,
  maxNameChar: 60
}